import React from 'react';
import styles from './App.module.scss';
import {
  CreativeSpaces,
  HeroCarousel,
  Jedi,
  NewsAndEvents,
  Programs,
  Testimonials,
  VideoPlayer,
} from './sections';

/**
 * This is the root React component.
 *
 * @component
 */
const App = () => {
  return (
    <div className={styles['root']}>
      <HeroCarousel />
      <NewsAndEvents />
      <Jedi />
      <Testimonials />
      <Programs />
      <CreativeSpaces />
      <VideoPlayer />
    </div>
  );
};

export default App;
